'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _lodash = require('lodash');

var _OrderSummaryTotalsStyle = require('./OrderSummaryTotalsStyle.scss');

var _OrderSummaryTotalsStyle2 = _interopRequireDefault(_OrderSummaryTotalsStyle);

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

var _order = require('../../helpers/order');

var _Adjustment = require('../Adjustment');

var _Adjustment2 = _interopRequireDefault(_Adjustment);

var _Total = require('../Adjustment/Total');

var _Total2 = _interopRequireDefault(_Total);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaintersOrderSummaryTotals = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_OrderSummaryTotalsStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaintersOrderSummaryTotals, _React$Component);

  function PaintersOrderSummaryTotals() {
    (0, _classCallCheck3.default)(this, PaintersOrderSummaryTotals);
    return (0, _possibleConstructorReturn3.default)(this, (PaintersOrderSummaryTotals.__proto__ || (0, _getPrototypeOf2.default)(PaintersOrderSummaryTotals)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaintersOrderSummaryTotals, [{
    key: 'withoutTax',
    value: function withoutTax(amount) {
      // return the original amount when the list is missing, empty or misses a property
      if (!this.props.order.taxRates || !this.props.order.taxRates[0] || !this.props.order.taxRates[0].amount) {
        return amount;
      }

      var taxRate = Math.abs(parseFloat(this.props.order.taxRates[0].amount));
      return amount / (1 + taxRate);
    }
  }, {
    key: 'summaryTotalClass',
    value: function summaryTotalClass() {
      if (!this.props.orderCompletePage) {
        return 'm-orderSummaryTotals';
      }

      return 'm-orderSummaryTotals m-orderSummaryTotals--complete';
    }
  }, {
    key: 'renderCouponPromotion',
    value: function renderCouponPromotion() {
      var amount = (0, _order.couponTotal)(this.props.order);
      var t = this.props.t;


      if (!amount) {
        return '';
      }
      return _react2.default.createElement(
        'li',
        { key: (0, _lodash.uniqueId)() },
        _react2.default.createElement(_Adjustment2.default, {
          title: t('discount'),
          amount: '-' + Money.format(amount, this.props.order.currency, this.props.config.store)
        })
      );
    }
  }, {
    key: 'renderDeliveryCost',
    value: function renderDeliveryCost() {
      if (!this.props.order.shipTotal || this.props.order.shipTotal <= 0) {
        return '';
      }

      var t = this.props.t;

      var selectedShippingRate = this.props.order.selected_shipping_rate;
      var description = selectedShippingRate ? selectedShippingRate.description : '';
      var amount = Money.format(this.withoutTax(this.props.order.shipTotal), this.props.order.currency, this.props.config.store);

      return _react2.default.createElement(
        'li',
        { key: (0, _lodash.uniqueId)() },
        _react2.default.createElement(_Adjustment2.default, {
          title: t('spree.delivery_cost'),
          information: description,
          amount: amount
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      var shippingRate = this.withoutTax(this.props.order.shipTotal);
      var subTotal = this.withoutTax(this.props.order.itemTotal);

      var total = shippingRate ? subTotal + shippingRate : subTotal;

      return _react2.default.createElement(
        'ul',
        { styleName: this.summaryTotalClass() },
        this.renderCouponPromotion(),
        (0, _order.automaticPromotions)(this.props.order.adjustments).map(function (adjustment) {
          return _react2.default.createElement(
            'li',
            { key: (0, _lodash.uniqueId)() },
            _react2.default.createElement(_Adjustment2.default, {
              title: adjustment.label,
              amount: '-' + Money.format(Math.abs(adjustment.amount), _this2.props.order.currency, _this2.props.config.store)
            })
          );
        }),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_Adjustment2.default, {
            title: t('spree.subtotal'),
            amount: '' + Money.format(subTotal, this.props.order.currency, this.props.config.store)
          })
        ),
        this.renderDeliveryCost(),
        _react2.default.createElement(
          'li',
          { styleName: 'orderTotal' },
          _react2.default.createElement(_Total2.default, {
            title: t('spree.total'),
            information: t('spree.excluding_tax'),
            amount: Money.format(total, this.props.order.currency, this.props.config.store)
          })
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_Adjustment2.default, {
            title: t('spree.tax'),
            amount: '' + Money.format(Math.abs(this.props.order.taxTotal), this.props.order.currency, this.props.config.store)
          })
        ),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(_Adjustment2.default, {
            title: t('spree.total'),
            information: t('spree.tax_included'),
            amount: this.props.order.displayTotal
          })
        )
      );
    }
  }]);
  return PaintersOrderSummaryTotals;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  orderCompletePage: _react.PropTypes.bool
}, _class2.defaultProps = {
  orderCompletePage: false
}, _temp)) || _class) || _class) || _class);
exports.default = PaintersOrderSummaryTotals;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderSummary/PaintersOrderSummaryTotals.js
// module id = 2481
// module chunks = 0